<template>
    <div>
        <hua-nav-bar
            :title="'预约详情'"
            left-arrow
            @click-left="onClickLeft"
            style="margin-bottom: 10px"
        ></hua-nav-bar>
        <book-detail
            :id="id"
            :operate="operate"
            :isv_id="isv_id"
            :v_timeStr="v_timeStr"
            :v_healthCodePic="v_healthCodePic"
            :reviewable="reviewable"
            :v_personid="v_personid"
            :isOrder="false"
            :isBookDetail="true"
        ></book-detail>
    </div>
</template>
<script>
import bookDetail from '../visitorBooking/components/invite.vue'
export default {
    components: {
        bookDetail,
    },
    data() {
        return {
            id: null,
            isv_id: null,
            v_personid: null,
            operate: '',
            v_timeStr: '',
            v_healthCodePic: '',
            reviewable: null,
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.isv_id = this.$route.params.isv_id
        this.operate = this.$route.params.active
        this.v_personid = this.$route.params.v_personid
        this.v_timeStr = this.$route.params.v_timeStr
        this.v_healthCodePic = this.$route.params.v_healthCodePic
        this.reviewable = this.$route.params.reviewable
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1)
            // this.$router.push({
            //     name: 'myVisitorList',
            //     params: { active: this.operate },
            // })
        },
    },
}
</script>